import React from 'react';
import { Link } from 'react-router-dom';
import './MainServices.css';

const MainServices = () => {
  const services = [
    {
      id: 1,
      title: '회사소개',
      description: '태봉산업기술의 역사와 비전',
      icon: '🏢',
      link: '/ko/company-overview'
    },
    {
      id: 2,
      title: '제품소개',
      description: '다양한 열교환기 제품 라인업',
      icon: '⚙️',
      link: '/ko/products'
    },
    {
      id: 3,
      title: '인증현황',
      description: '국제 표준 인증 및 품질 보증',
      icon: '🏆',
      link: '/ko/certification-detail'
    },
    {
      id: 4,
      title: '납품실적',
      description: '플랜트 및 HVAC 시스템 납품 실적',
      icon: '🏭',
      link: '/ko/delivery-performance'
    },
    {
      id: 5,
      title: '고객지원',
      description: '전문적인 기술 지원 및 서비스',
      icon: '🔧',
      link: '/ko/customer-support'
    },
    {
      id: 6,
      title: 'ESG',
      description: '지속가능한 경영과 사회적 책임',
      icon: '🌱',
      link: '/ko/esg'
    }
  ];

  return (
    <section className="main-services" id="main-services">
      <div className="main-services-container">
        <div className="main-services-header">
          <h2 className="main-services-title">주요 서비스</h2>
          <p className="main-services-subtitle">산업용 열교환 솔루션을 위한 포괄적인 서비스</p>
        </div>
        <div className="main-services-grid">
          {services.map((service) => (
            <Link key={service.id} to={service.link} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MainServices;
